import { useEffect } from 'react';

const ImprovedSeo = () => {
    const siteUrl = "https://mathaganerinarayanaswamykovil.com";

    // Simplified, natural title
    const siteTitle = "மதகநேரி நாராயணசுவாமி கோவில் | மதகநெல்லூர்";

    // Natural description without keyword stuffing
    const siteDescription =
        "மதகநேரி நாராயணசுவாமி கோவில் - மதகநெல்லூர் மான்கூடுதலம் பகுதியில் அமைந்துள்ள பழமையான வைஷ்ணவ திருக்கோவில். முடி புகழ்ந்த அம்மானை ஏடு வழிபாட்டு தலம். கோவில் வரலாறு, திருவிழாக்கள் மற்றும் வழிபாட்டு நேரங்கள்.";

    // Reduced and natural keywords only
    const keywords = [
        "மதகநேரி கோவில்",
        "நாராயணசுவாமி கோவில்",
        "மதகநெல்லூர் கோவில்",
        "mathaganeri temple",
        "narayanaswamy temple"
    ].join(", ");

    const ogImage = `${siteUrl}/og-image.jpg`;

    // Simplified structured data
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "HinduTemple",
        "name": "மதகநேரி நாராயணசுவாமி கோவில்",
        "alternateName": "Mathaganeri Narayanaswamy Temple",
        "description": siteDescription,
        "url": siteUrl,
        "image": ogImage,
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "மதகநெல்லூர்",
            "addressLocality": "மதகநேரி",
            "addressRegion": "Tamil Nadu",
            "postalCode": "625020",
            "addressCountry": "IN"
        },
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": "9.9252",
            "longitude": "78.1198"
        }
    };

    useEffect(() => {
        // Set document title
        document.title = siteTitle;

        // Update meta tags
        const updateMetaTag = (name, content, isProperty = false) => {
            const attr = isProperty ? 'property' : 'name';
            let meta = document.querySelector(`meta[${attr}="${name}"]`);
            if (!meta) {
                meta = document.createElement('meta');
                meta.setAttribute(attr, name);
                document.head.appendChild(meta);
            }
            meta.setAttribute('content', content);
        };

        // Core Meta Tags
        updateMetaTag('description', siteDescription);
        updateMetaTag('keywords', keywords);

        // Geographic
        updateMetaTag('geo.region', 'IN-TN');
        updateMetaTag('geo.placename', 'மதகநேரி, தமிழ்நாடு');
        updateMetaTag('geo.position', '9.9252;78.1198');

        // Robots
        updateMetaTag('robots', 'index, follow, max-image-preview:large');
        updateMetaTag('googlebot', 'index, follow');

        // Open Graph
        updateMetaTag('og:site_name', 'மதகநேரி நாராயணசுவாமி கோவில்', true);
        updateMetaTag('og:title', siteTitle, true);
        updateMetaTag('og:description', siteDescription, true);
        updateMetaTag('og:type', 'website', true);
        updateMetaTag('og:url', siteUrl, true);
        updateMetaTag('og:image', ogImage, true);
        updateMetaTag('og:locale', 'ta_IN', true);

        // Twitter Card
        updateMetaTag('twitter:card', 'summary_large_image');
        updateMetaTag('twitter:title', siteTitle);
        updateMetaTag('twitter:description', siteDescription);
        updateMetaTag('twitter:image', ogImage);

        // Mobile
        updateMetaTag('theme-color', '#ff6b35');
        updateMetaTag('apple-mobile-web-app-capable', 'yes');

        // Add canonical link
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', siteUrl);

        // Add structured data
        let scriptTag = document.querySelector('script[type="application/ld+json"]');
        if (!scriptTag) {
            scriptTag = document.createElement('script');
            scriptTag.setAttribute('type', 'application/ld+json');
            document.head.appendChild(scriptTag);
        }
        scriptTag.textContent = JSON.stringify(structuredData);

        // Set HTML lang attribute
        document.documentElement.setAttribute('lang', 'ta');
    }, []);

    return null;
};

export default ImprovedSeo;